import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pricing-card__name" }
const _hoisted_2 = { class: "pricing-card__price" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pricing-card__term" }, " per month ", -1)
const _hoisted_4 = { class: "pricing-card__features" }
const _hoisted_5 = { class: "pricing-card__feature-title" }
const _hoisted_6 = {
  key: 0,
  class: "pricing-card__subscribe button--disabled"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Subscribe ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.gradientBorder ? 'pricing-card--outlined' : 'pricing-card')
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.price), 1),
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "pricing-card__feature",
          key: index
        }, [
          _createVNode(_component_fa_icon, {
            class: "success text--large",
            icon: ['far', 'check']
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(feature), 1)
        ]))
      }), 128))
    ]),
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Coming soon "))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "pricing-card__subscribe button--primary",
          to: "/dashboard"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-right'] })
          ]),
          _: 1
        }))
  ], 2))
}